export default __webpack_public_path__ + "static/media/brookshirebrotherscirclelogo.cfa09c45.jpg";